<template>
    <div class="scroll-indicator d-flex justify-content-center align-items-center">
        <img 
            v-svg-inline
            class="scroll-indicator__icon"
            :class="`fill-${variant}`"
            src="@/assets/ui/scrollbar_01.svg" 
        />
    </div>
</template>
<script>
export default {
    name: 'scrollIndicator',
    props: {
        variant: {
            type: String,
            default: 'bq-green'
        }
    }
}
</script>
<style lang="scss">
@keyframes example {
    0%   { opacity: 0; right: 0; }
    10%  { opacity: 1; right: 0; }
    90%  { opacity: 1; right: 0; }
    100% { opacity: 0; right: -40px; }
}

.scroll-indicator {
    height: 80px;
    width: 40px;
    border-radius: 10px 0 0 10px;
    background-color: rgba(222,228,234,0.4);
    position: fixed;
    right: -40px;
    top: 45%;
    z-index: 10;
    animation-name: example;
    animation-duration: 3s;
    animation-timing-function: ease-out;
    opacity: 0;
}

</style>
